/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * React context contract and consumer hooks for IAM.Voice localization. The
 * module deliberately contains no JSX or visual components so hot reload can
 * treat the provider and language switcher as component-only exports.
 */

import { createContext, useContext } from 'react';
import type { Locale, TranslationParams } from './catalog';

export type I18nContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string, params?: TranslationParams) => string;
};

export const I18nContext = createContext<I18nContextValue | null>(null);

/** Returns the full locale state and fails fast when the provider is missing. */
export function useI18n(): I18nContextValue {
  const value = useContext(I18nContext);
  if (!value) throw new Error('useI18n must be used inside I18nProvider');
  return value;
}

/** Returns the stable catalog translator for the active locale. */
export function useTranslation(): I18nContextValue['t'] {
  return useI18n().t;
}
